import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"align":"center","justify":"center"}},[_c('a',{staticClass:"dashboard-link",attrs:{"href":"/"}},[_c(VIcon,[_vm._v("mdi-arrow-left")]),_vm._v(" Back to Dashboard")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }